var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-12" }, [
    _c(
      "div",
      { staticClass: "search-padd" },
      [
        _c(
          "form",
          {
            on: {
              change: _vm.captureModificationsEvent,
              submit: function($event) {
                $event.preventDefault()
              }
            }
          },
          [
            _c("div", { staticClass: "col-xs-12 override-padding" }, [
              _c(
                "div",
                {
                  staticClass:
                    "crm_admin_heading admin_heading_1 text-align-left"
                },
                [_vm._v("+/-")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "crm_admin_heading mentee_heading_6 text-align-left"
                },
                [_vm._v("First Name")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "crm_admin_heading mentee_heading_6 text-align-left"
                },
                [_vm._v("Last Name")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "crm_admin_heading mentee_heading_15 text-align-left"
                },
                [_vm._v("Email")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "crm_admin_heading mentee_heading_16 text-align-left"
                },
                [_vm._v("Mobile No")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "crm_admin_heading prospect_heading_5 text-align-center"
                },
                [_vm._v("Status")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "crm_admin_heading mentee_heading_14 text-align-center"
                },
                [_vm._v("Contact")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "crm_admin_heading prospect_heading_5 text-align-center"
                },
                [_vm._v("Preferences")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "crm_admin_heading mentee_heading_13 text-align-left"
                },
                [_vm._v(_vm._s(_vm.mentor_label_name))]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "crm_admin_heading mentee_heading_13 text-align-left"
                },
                [_vm._v("Pathway(s)")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "crm_admin_heading mentee_heading_12 text-align-center"
                },
                [_vm._v(" ")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticStyle: { clear: "both" } }),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                staticClass: "loading_show"
              },
              [_c("div", { staticClass: "spinner-border text-danger" })]
            ),
            _vm._v(" "),
            _vm._l(_vm.account_mentees, function(account_mentee, index) {
              return _c(
                "div",
                [
                  _c(
                    "div",
                    {
                      class: "admin_details" + index,
                      attrs: { id: "mentee_details_more" + index }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "crm_admin_field_lists admin_heading_1 text-align-center font-25 line-height-30"
                        },
                        [
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle",
                                  value: "collapse_" + index,
                                  expression: "'collapse_' + index"
                                }
                              ]
                            },
                            [
                              _c("span", { staticClass: "when-opened" }, [
                                _vm._v("-")
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "when-closed" }, [
                                _vm._v("+")
                              ])
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "crm_admin_field_lists mentee_heading_6 text-align-left"
                        },
                        [
                          _c("div", { staticClass: "search-padd" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: account_mentee.uid,
                                  expression: "account_mentee.uid"
                                }
                              ],
                              attrs: {
                                type: "hidden",
                                name: "uid[" + index + "]",
                                id: "uid_" + index
                              },
                              domProps: { value: account_mentee.uid },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    account_mentee,
                                    "uid",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: account_mentee.mentee_fname,
                                  expression: "account_mentee.mentee_fname"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    rules: {
                                      required: true,
                                      regex: _vm.nameRegex()
                                    }
                                  },
                                  expression:
                                    "{ rules: { required: true, regex: nameRegex() } }"
                                }
                              ],
                              ref: "mentee_fname",
                              refInFor: true,
                              staticClass: "col-12 col-sm-12 ma-input-field",
                              attrs: {
                                type: "text",
                                id: "mentee_fname_" + index,
                                name: "mentee_fname[" + index + "]",
                                placeholder: "First Name",
                                maxlength: "250"
                              },
                              domProps: { value: account_mentee.mentee_fname },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    account_mentee,
                                    "mentee_fname",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _vm.verrors.firstByRule(
                              "mentee_fname[" + index + "]",
                              "required"
                            )
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "margin-bottom-5 validate-warning-msg"
                                  },
                                  [_vm._v("First name is required")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.verrors.firstByRule(
                              "mentee_fname[" + index + "]",
                              "regex"
                            )
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "margin-bottom-5 validate-warning-msg"
                                  },
                                  [
                                    _vm._v(
                                      "First name should only contain - and _"
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "search-padd",
                              staticStyle: {
                                width: "155px",
                                "margin-top": "2px"
                              }
                            },
                            [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: account_mentee.step_assigned,
                                      expression: "account_mentee.step_assigned"
                                    }
                                  ],
                                  staticClass: "custom-select",
                                  attrs: {
                                    id: "step_assigned_" + index,
                                    name: "step_assigned[" + index + "]"
                                  },
                                  on: {
                                    focus: function($event) {
                                      return _vm.getStatusOldValue(
                                        index,
                                        $event
                                      )
                                    },
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        account_mentee,
                                        "step_assigned",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                _vm._l(account_mentee.steps, function(
                                  item,
                                  index
                                ) {
                                  return _c(
                                    "option",
                                    {
                                      key: index,
                                      domProps: { value: item.value }
                                    },
                                    [_vm._v(_vm._s(item.text))]
                                  )
                                }),
                                0
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "crm_admin_field_lists mentee_heading_6 text-align-left"
                        },
                        [
                          _c("div", { staticClass: "search-padd" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: account_mentee.mentee_lname,
                                  expression: "account_mentee.mentee_lname"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    rules: {
                                      required: true,
                                      regex: _vm.nameRegex()
                                    }
                                  },
                                  expression:
                                    "{ rules: { required: true, regex: nameRegex() } }"
                                }
                              ],
                              ref: "mentee_lname",
                              refInFor: true,
                              staticClass: "col-12 col-sm-12 ma-input-field",
                              attrs: {
                                type: "text",
                                id: "mentee_lname_" + index,
                                name: "mentee_lname[" + index + "]",
                                placeholder: "Last Name",
                                maxlength: "250"
                              },
                              domProps: { value: account_mentee.mentee_lname },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    account_mentee,
                                    "mentee_lname",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _vm.verrors.firstByRule(
                              "mentee_lname[" + index + "]",
                              "required"
                            )
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "margin-bottom-5 validate-warning-msg"
                                  },
                                  [_vm._v("Last name is required")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.verrors.firstByRule(
                              "mentee_lname[" + index + "]",
                              "regex"
                            )
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "margin-bottom-5 validate-warning-msg"
                                  },
                                  [
                                    _vm._v(
                                      "Last name should only contain - and _"
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "crm_admin_field_lists mentee_heading_15 text-align-left"
                        },
                        [
                          _c("div", { staticClass: "search-padd" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: account_mentee.mentee_email,
                                  expression: "account_mentee.mentee_email"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|email",
                                  expression: "'required|email'"
                                }
                              ],
                              ref: "mentee_email",
                              refInFor: true,
                              staticClass: "col-12 col-sm-12 ma-input-field",
                              attrs: {
                                type: "text",
                                id: "mentee_email_" + index,
                                name: "mentee_email[" + index + "]",
                                placeholder: "Email",
                                autocomplete: "off",
                                maxlength: "250"
                              },
                              domProps: { value: account_mentee.mentee_email },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    account_mentee,
                                    "mentee_email",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _vm.verrors.firstByRule(
                              "mentee_email[" + index + "]",
                              "required"
                            )
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "margin-bottom-5 validate-warning-msg"
                                  },
                                  [_vm._v("Email is required")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.verrors.firstByRule(
                              "mentee_email[" + index + "]",
                              "email"
                            )
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "margin-bottom-5 validate-warning-msg"
                                  },
                                  [_vm._v("Email is invalid")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.verrors.firstByRule(
                              "mentee_email[" + index + "]",
                              "exists"
                            )
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "margin-bottom-5 validate-warning-msg"
                                  },
                                  [_vm._v("Email address already exists")]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "search-padd",
                              staticStyle: {
                                width: "330px",
                                "margin-top": "2px"
                              }
                            },
                            [
                              _c("div", { staticClass: "form-group row" }, [
                                _c("div", { staticClass: "col-6" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: account_mentee.future_step,
                                        expression: "account_mentee.future_step"
                                      }
                                    ],
                                    ref: "future_step",
                                    refInFor: true,
                                    staticStyle: { "margin-top": "10px" },
                                    attrs: {
                                      type: "checkbox",
                                      id: "future_step_" + index,
                                      name: "future_step[" + index + "]"
                                    },
                                    domProps: {
                                      checked:
                                        account_mentee.future_step_checked,
                                      value: 1,
                                      checked: Array.isArray(
                                        account_mentee.future_step
                                      )
                                        ? _vm._i(
                                            account_mentee.future_step,
                                            1
                                          ) > -1
                                        : account_mentee.future_step
                                    },
                                    on: {
                                      change: [
                                        function($event) {
                                          var $$a = account_mentee.future_step,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = 1,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  account_mentee,
                                                  "future_step",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  account_mentee,
                                                  "future_step",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              account_mentee,
                                              "future_step",
                                              $$c
                                            )
                                          }
                                        },
                                        function($event) {
                                          return _vm.mentee_future_step_change(
                                            index,
                                            $event
                                          )
                                        }
                                      ]
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticStyle: { color: "#002F42" },
                                      attrs: { for: "submit_comment_1" }
                                    },
                                    [_vm._v("Show future steps")]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-6" }, [
                                  account_mentee.uid == 0
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              account_mentee.assign_license,
                                            expression:
                                              "account_mentee.assign_license"
                                          }
                                        ],
                                        ref: "assign_license",
                                        refInFor: true,
                                        staticStyle: { "margin-top": "10px" },
                                        attrs: {
                                          type: "checkbox",
                                          id: "assign_license_" + index,
                                          name: "assign_license[" + index + "]",
                                          disabled:
                                            account_mentee.assign_license_disabled
                                        },
                                        domProps: {
                                          value: 1,
                                          checked: Array.isArray(
                                            account_mentee.assign_license
                                          )
                                            ? _vm._i(
                                                account_mentee.assign_license,
                                                1
                                              ) > -1
                                            : account_mentee.assign_license
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.mentee_license_assigned(
                                              index,
                                              $event
                                            )
                                          },
                                          change: function($event) {
                                            var $$a =
                                                account_mentee.assign_license,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = 1,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  _vm.$set(
                                                    account_mentee,
                                                    "assign_license",
                                                    $$a.concat([$$v])
                                                  )
                                              } else {
                                                $$i > -1 &&
                                                  _vm.$set(
                                                    account_mentee,
                                                    "assign_license",
                                                    $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      )
                                                  )
                                              }
                                            } else {
                                              _vm.$set(
                                                account_mentee,
                                                "assign_license",
                                                $$c
                                              )
                                            }
                                          }
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  account_mentee.uid == 0
                                    ? _c(
                                        "label",
                                        {
                                          staticStyle: { color: "#002F42" },
                                          attrs: { for: "submit_comment_1" }
                                        },
                                        [_vm._v("Assign license")]
                                      )
                                    : _vm._e()
                                ])
                              ])
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "crm_admin_field_lists mentee_heading_16 text-align-center"
                        },
                        [
                          _c("div", { staticClass: "search-padd" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: account_mentee.mentee_phone,
                                  expression: "account_mentee.mentee_phone"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { rules: { regex: _vm.phoneRegex() } },
                                  expression:
                                    "{ rules: { regex: phoneRegex() } }"
                                }
                              ],
                              ref: "mentee_phone",
                              refInFor: true,
                              staticClass: "col-12 col-sm-12 ma-input-field",
                              attrs: {
                                type: "text",
                                id: "mentee_phone_" + index,
                                name: "mentee_phone[" + index + "]",
                                placeholder: "Mobile Number",
                                maxlength: "14"
                              },
                              domProps: { value: account_mentee.mentee_phone },
                              on: {
                                keyup: function($event) {
                                  return _vm.phoneValid($event, index)
                                },
                                blur: function($event) {
                                  return _vm.phoneValid($event, index)
                                },
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    account_mentee,
                                    "mentee_phone",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _vm.verrors.firstByRule(
                              "mentee_phone[" + index + "]",
                              "regex"
                            )
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "margin-bottom-5 validate-warning-msg"
                                  },
                                  [_vm._v("Mobile number is invalid")]
                                )
                              : _vm._e()
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "crm_admin_field_lists prospect_heading_5 text-align-center"
                        },
                        [
                          _c("div", { staticClass: "search-padd" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: account_mentee.mentee_status,
                                    expression: "account_mentee.mentee_status"
                                  }
                                ],
                                staticClass: "custom-select",
                                attrs: {
                                  id: "mentee_status_" + index,
                                  name: "mentee_status[" + index + "]"
                                },
                                on: {
                                  focus: function($event) {
                                    return _vm.getStatusOldValue(index, $event)
                                  },
                                  change: [
                                    function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        account_mentee,
                                        "mentee_status",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                    function($event) {
                                      return _vm.mentee_status_change(
                                        index,
                                        $event
                                      )
                                    }
                                  ]
                                }
                              },
                              _vm._l(_vm.user_status_options, function(
                                item,
                                index
                              ) {
                                return _c(
                                  "option",
                                  {
                                    key: index,
                                    domProps: { value: item.value }
                                  },
                                  [_vm._v(_vm._s(item.text))]
                                )
                              }),
                              0
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "crm_admin_field_lists mentee_heading_14 text-align-center",
                          staticStyle: { "padding-top": "16px" }
                        },
                        [
                          _c("div", { staticClass: "search-padd" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-sm ma-blue-btn",
                                on: {
                                  click: function($event) {
                                    return _vm.openContactModal(index)
                                  }
                                }
                              },
                              [_vm._v("Contact")]
                            )
                          ]),
                          _vm._v(" "),
                          account_mentee.is_transfer_status == 1
                            ? _c(
                                "div",
                                {
                                  staticClass: "search-padd",
                                  staticStyle: {
                                    "margin-top": "20px",
                                    width: "auto",
                                    "text-align": "center"
                                  },
                                  attrs: { id: "mentee-group-wrapper" }
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "goal-indicator-btn greenBtn"
                                    },
                                    [_vm._v("Transferred")]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          account_mentee.uid > 0
                            ? _c(
                                "div",
                                {
                                  staticClass: "search-padd",
                                  staticStyle: { "margin-top": "10px" }
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-sm ma-blue-btn",
                                      on: {
                                        click: function($event) {
                                          return _vm.openSettingsModal(index)
                                        }
                                      }
                                    },
                                    [_vm._v("Settings")]
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "crm_admin_field_lists prospect_heading_5 text-align-center",
                          staticStyle: { "padding-top": "16px" }
                        },
                        [
                          _c("div", { staticClass: "search-padd" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-sm ma-blue-btn",
                                on: {
                                  click: function($event) {
                                    return _vm.openUserPreferenceModal(index)
                                  }
                                }
                              },
                              [_vm._v("Preferences")]
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "crm_admin_field_lists mentee_heading_13 text-align-center"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "search-padd",
                              attrs: { id: "mentee-group-wrapper" }
                            },
                            [
                              _c("multiselect", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  options: _vm.mentors,
                                  "track-by": "name",
                                  label: "name",
                                  placeholder: "Select",
                                  multiple: true,
                                  "close-on-select": false,
                                  "show-labels": false,
                                  name: "mentor_assigned[" + index + "]",
                                  id: "mentor_assigned" + index
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.captureMultiselectModificationAction(
                                      index,
                                      "mentor_assigned",
                                      account_mentee.mentor_assigned
                                    )
                                  },
                                  select: function($event) {
                                    return _vm.toggleSelected($event, index)
                                  },
                                  remove: function($event) {
                                    return _vm.toggleRemoved($event, index)
                                  }
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "selection",
                                    fn: function(ref) {
                                      var values = ref.values
                                      var search = ref.search
                                      var isOpen = ref.isOpen
                                      return [
                                        values.length && !isOpen
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "multiselect__single"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(values.length) +
                                                    " selected"
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ]),
                                model: {
                                  value: account_mentee.mentor_assigned,
                                  callback: function($$v) {
                                    _vm.$set(
                                      account_mentee,
                                      "mentor_assigned",
                                      $$v
                                    )
                                  },
                                  expression: "account_mentee.mentor_assigned"
                                }
                              }),
                              _vm._v(" "),
                              _vm.verrors.firstByRule(
                                "mentor_assigned[" + index + "]",
                                "required"
                              )
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "margin-bottom-5 validate-warning-msg"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.mentor_label_name) +
                                          " is required"
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "crm_admin_field_lists mentee_heading_13 text-align-left"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "search-padd",
                              attrs: { id: "mentee-tasklist-wrapper" }
                            },
                            [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: account_mentee.pathway_assigned,
                                      expression:
                                        "account_mentee.pathway_assigned"
                                    }
                                  ],
                                  staticClass: "custom-select",
                                  attrs: {
                                    id: "pathway_assigned_" + index,
                                    name: "pathway_assigned[" + index + "]"
                                  },
                                  on: {
                                    focus: function($event) {
                                      return _vm.getStatusOldValue(
                                        index,
                                        $event
                                      )
                                    },
                                    change: [
                                      function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          account_mentee,
                                          "pathway_assigned",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                      function($event) {
                                        return _vm.mentee_pathway_change(
                                          index,
                                          $event
                                        )
                                      }
                                    ]
                                  }
                                },
                                _vm._l(_vm.pathways, function(item, index) {
                                  return _c(
                                    "option",
                                    {
                                      key: index,
                                      domProps: { value: item.value }
                                    },
                                    [_vm._v(_vm._s(item.text))]
                                  )
                                }),
                                0
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "crm_admin_field_lists mentee_heading_12 text-align-center"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "search-padd delete-icon" },
                            [
                              _c("i", {
                                staticClass:
                                  "fa fa-window-close cursor-pointer",
                                attrs: { "aria-hidden": "true" },
                                on: {
                                  click: function($event) {
                                    return _vm.confirmRemoveMentee(index)
                                  }
                                }
                              })
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticStyle: { clear: "both" } }),
                  _vm._v(" "),
                  _c("b-collapse", { attrs: { id: "collapse_" + index } }, [
                    _c(
                      "div",
                      { staticClass: "col-md-6 float-left override-padding" },
                      [
                        _c("div", { staticClass: "col-12" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: account_mentee.password,
                                expression: "account_mentee.password"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "min:6",
                                expression: "'min:6'"
                              }
                            ],
                            staticClass: "col-12 col-sm-12 ma-input-field",
                            attrs: {
                              type: "password",
                              name: "newpassword[" + index + "]",
                              id: "newpassword_" + index,
                              placeholder: "Password",
                              maxlength: "20",
                              role: "presentation",
                              autoComplete: "new-password"
                            },
                            domProps: { value: account_mentee.password },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  account_mentee,
                                  "password",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.verrors.has(
                                    "newpassword[" + index + "]"
                                  ),
                                  expression:
                                    "verrors.has('newpassword[' + index + ']')"
                                }
                              ],
                              staticClass: "validate-warning-msg"
                            },
                            [
                              _vm._v(
                                "The password field must be at least 6 characters"
                              )
                            ]
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-6 float-left override-padding" },
                      [_c("div", { staticClass: "col-12" })]
                    ),
                    _vm._v(" "),
                    _c("div", { staticStyle: { clear: "both" } })
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: "admin_details" + index,
                      attrs: { id: "mentee_details_more" + index }
                    },
                    [
                      _c("div", { staticClass: "course-title" }, [
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "b-toggle",
                                rawName: "v-b-toggle",
                                value: "courses_collapse_" + index,
                                expression: "'courses_collapse_' + index"
                              }
                            ]
                          },
                          [
                            _vm._v("\n          Courses "),
                            _c("span", { staticClass: "when-opened" }, [
                              _vm._v("-")
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "when-closed" }, [
                              _vm._v("+")
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-collapse",
                        {
                          attrs: { id: "courses_collapse_" + index },
                          on: {
                            shown: function($event) {
                              return _vm.getCoursesInfo(index)
                            }
                          }
                        },
                        [
                          _c("CourseUserResultsHeader", {
                            ref: "course_user_results_header_" + index,
                            refInFor: true
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticStyle: { clear: "both", "margin-top": "10px" }
                  })
                ],
                1
              )
            }),
            _vm._v(" "),
            _vm.account_mentees.length < 50 && _vm.account_type == "Company"
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-red btn-group-sm",
                    on: {
                      click: function($event) {
                        return _vm.addMentee()
                      }
                    }
                  },
                  [_vm._m(0)]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.account_mentees.length < 50 && _vm.account_type == "School"
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-red btn-group-sm",
                    on: {
                      click: function($event) {
                        return _vm.addMentee()
                      }
                    }
                  },
                  [_vm._m(1)]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", {
              staticClass: "margin-bottom-10",
              staticStyle: { clear: "both" }
            }),
            _vm._v(" "),
            _c(
              "DeleteModal",
              {
                attrs: {
                  isModalVisible: _vm.isDeleteModalVisible,
                  id: _vm.delete_id,
                  parent_id: _vm.parent_id
                },
                on: {
                  close: function($event) {
                    _vm.isDeleteModalVisible = false
                  }
                }
              },
              [
                _vm.loading
                  ? _c("span", { staticClass: "pull-right text-danger" }, [
                      _vm._v("\n        Loading...\n      ")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.account_type == "School"
                  ? _c(
                      "div",
                      {
                        staticClass: "sub-heading",
                        attrs: { slot: "header" },
                        slot: "header"
                      },
                      [
                        _vm._v(
                          "\n        Are you sure you want to delete the student?\n      "
                        )
                      ]
                    )
                  : _c(
                      "div",
                      {
                        staticClass: "sub-heading",
                        attrs: { slot: "header" },
                        slot: "header"
                      },
                      [
                        _vm._v(
                          "\n        Are you sure you want to delete the user?\n      "
                        )
                      ]
                    ),
                _vm._v(" "),
                _c("div", { attrs: { slot: "body" }, slot: "body" }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "col-3 override-padding",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "left col-12 btn btn-red",
                        on: {
                          click: function($event) {
                            _vm.isDeleteModalVisible = false
                            _vm.deleteMenteeAction(_vm.delete_id)
                          }
                        }
                      },
                      [_vm._v("Confirm")]
                    )
                  ]
                )
              ]
            )
          ],
          2
        ),
        _vm._v(" "),
        _c("ContactModal", {
          ref: "admin_contact_form",
          attrs: {
            isModalVisible: _vm.isContactModalVisible,
            id: _vm.delete_id,
            parent_id: _vm.parent_id
          },
          on: {
            close: function($event) {
              _vm.isContactModalVisible = false
            }
          }
        }),
        _vm._v(" "),
        _c("MenteeSettingsModal", {
          ref: "mentee_settings_form",
          attrs: { isModalVisible: _vm.isMenteeSettingsModalVisible },
          on: {
            close: function($event) {
              _vm.isMenteeSettingsModalVisible = false
            }
          }
        }),
        _vm._v(" "),
        _c("UserPreferenceModal", {
          ref: "user_preference",
          attrs: { isModalVisible: _vm.isUserPreferenceModalVisible },
          on: {
            close: function($event) {
              _vm.isUserPreferenceModalVisible = false
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("b", [
      _c("i", {
        staticClass: "fa fa-plus spacer-icon",
        attrs: { "aria-hidden": "true" }
      }),
      _vm._v("New User")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("b", [
      _c("i", {
        staticClass: "fa fa-plus spacer-icon",
        attrs: { "aria-hidden": "true" }
      }),
      _vm._v("New Student")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28aa9887", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28aa9887","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/account_lookup_mentee_tab.vue
// module id = null
// module chunks = 